// src/views/common/Unauthorized.jsx
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Logo from "../../assets/images/logo.svg";

const Unauthorized = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const getPrimaryWorkspace = () => {
    const roleId = Number(user?.role_id);
    if (roleId === 7) return "/pharmacy";
    if (roleId === 8) return "/billing";
    if (roleId === 6) return "/create-lab-report";
    if (roleId === 1 || roleId === 2 || roleId === 11) return "/dashboard";
    return "/patients";
  };

  return (
    <div className="container-fluid">
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "75vh", padding: "30px 15px" }}
      >
        <div
          className="bg-white border rounded-3 text-center p-4 p-md-5"
          style={{
            maxWidth: "500px",
            width: "100%",
            borderColor: "#E5E7EB",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.04)",
          }}
        >
          <div className="mb-3">
            <img src={Logo} alt="HMIS Logo" style={{ height: "42px" }} />
          </div>

          <div
            className="mx-auto mb-3 d-flex align-items-center justify-content-center"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              backgroundColor: "#FEF2F2",
              color: "#DC2626",
              fontSize: "26px",
              fontWeight: 700,
            }}
          >
            !
          </div>

          <h4 style={{ color: "#1F2A37", fontWeight: 700, fontSize: "20px", marginBottom: "8px" }}>
            Access Restricted
          </h4>

          <p style={{ color: "#6B7280", fontSize: "14px", lineHeight: 1.5, marginBottom: "20px" }}>
            Your account is authenticated, but your current clinical/staff role does not have authorization to view this module.
          </p>

          {user && (
            <div
              className="p-3 mb-4 rounded-2 text-start"
              style={{ backgroundColor: "#F9FAFB", border: "1px solid #E5E7EB", fontSize: "13px" }}
            >
              <div className="d-flex justify-content-between mb-1">
                <span style={{ color: "#6B7280" }}>Account:</span>
                <strong>{user.name || user.email}</strong>
              </div>
              <div className="d-flex justify-content-between">
                <span style={{ color: "#6B7280" }}>Assigned Role:</span>
                <span
                  style={{
                    backgroundColor: "#EBF5FF",
                    color: "#1C64F2",
                    padding: "2px 8px",
                    borderRadius: "12px",
                    fontWeight: 600,
                    fontSize: "11px",
                  }}
                >
                  {user.role_name || `Role #${user.role_id}`}
                </span>
              </div>
            </div>
          )}

          <div className="d-flex justify-content-center gap-3">
            <button
              type="button"
              className="customeBtn btnEmpty"
              style={{ padding: "8px 20px" }}
              onClick={() => navigate(-1)}
            >
              Go Back
            </button>
            <Link
              to={getPrimaryWorkspace()}
              className="customeBtn successBtn"
              style={{ padding: "8px 20px", textDecoration: "none" }}
            >
              Primary Workspace
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
